import { useNavigate } from 'react-router-dom';
import { animeList } from '@/mocks/anime';

export default function LatestUpdates() {
  const navigate = useNavigate();
  const latest = [...animeList]
    .sort((a, b) => b.year - a.year)
    .slice(0, 6);

  const handleClick = (id: string) => {
    navigate(`/article/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最近更新
            </h2>
            <p className="text-sm text-foreground-600 mt-2">最新的番剧更新，追番不迷路</p>
          </div>
        </div>

        <div className="space-y-3">
          {latest.map((anime, index) => (
            <div
              key={anime.id}
              className="flex items-center gap-4 p-4 bg-background-100 rounded-xl cursor-pointer hover:bg-background-200/70 transition-colors border border-background-200/70"
              onClick={() => handleClick(anime.id)}
            >
              <span className="text-lg font-heading font-bold text-foreground-300 w-8 text-center whitespace-nowrap">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="w-12 h-16 rounded-md overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-950 hover:text-primary-500 transition-colors line-clamp-1">
                  {anime.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{anime.updateInfo}</p>
              </div>
              <div className="hidden sm:flex items-center gap-2 flex-wrap flex-shrink-0">
                {anime.tags.slice(0, 3).map((tag) => (
                  <span key={tag} className="text-xs text-foreground-500 bg-background-50 px-2 py-0.5 rounded-full border border-background-200/70 whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-accent-500 text-sm"></i>
                </span>
                <span className="text-sm font-medium text-foreground-700">{anime.rating}</span>
              </div>
              <span className={`text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap flex-shrink-0 ${
                anime.status === '连载中' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
              }`}>
                {anime.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}